import { useMutation, useQuery } from "react-query";
import {
  addProduct,
  getProduct,
  getProducts,
  Http_GET_Products,
  importProduct,
  updateProduct,
} from "./service";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
import { AxiosError } from "axios";
import useSuccessHandler from "../../../../hooks/useSuccessHandler";
import { Form_Create_Product } from "../../form/FormCreate";
import { Form_Update_Product } from "../../form/FormUpdate";
import { useNavigate } from "react-router";

export const useGetProducts = ({
  has_tax,
  keyword,
  max_price,
  min_price,
  page,
  perPage,
  product_brand_id,
  product_category_id,
  stock,
}: Http_GET_Products) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    queryKey: `products-${has_tax}-${keyword}-${max_price}-${min_price}-${page}-${perPage}-${product_brand_id}-${product_category_id}-${stock}`,
    queryFn: () =>
      getProducts({
        has_tax,
        keyword,
        max_price,
        min_price,
        page,
        perPage,
        product_brand_id,
        product_category_id,
        stock,
      }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useGetProduct = ({ product_id }: { product_id: string }) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    enabled: product_id !== undefined,
    queryKey: `productDetails-${product_id}`,
    queryFn: () => getProduct({ product_id }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useAddProduct = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({
      buying_price,
      has_tax,
      price,
      product_brand_id,
      product_category_id,
      product_type_name,
      stock,
      unit_type,
      wholesale_price,
      skip_stock,
    }: Form_Create_Product) =>
      addProduct({
        buying_price,
        has_tax,
        price,
        product_brand_id,
        product_category_id,
        product_type_name,
        stock,
        unit_type,
        wholesale_price,
        skip_stock,
      }),
    onSuccess: (e) => {
      showToast("Berhasil menambahkan produk baru");
      navigate("/produk");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useUpdateProduct = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({
      product_id,
      buying_price,
      has_tax,
      price,
      product_brand_id,
      product_category_id,
      product_type_name,
      stock,
      unit_type,
      wholesale_price,
    }: Form_Update_Product) =>
      updateProduct({
        product_id,
        buying_price,
        has_tax,
        price,
        product_brand_id,
        product_category_id,
        product_type_name,
        stock,
        unit_type,
        wholesale_price,
      }),
    onSuccess: (e) => {
      showToast("Berhasil update produk");
      navigate("/produk");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useImportProduct = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();

  return useMutation({
    mutationKey: ["importProduct"],
    mutationFn: ({ file }: { file: File }) => importProduct({ file }),
    onSuccess: (e) => showToast("Berhasil melakukan import produk"),
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
